import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import { formatDateIntoDMM, formatDateIntoDMMMY } from "Utils/utils";
import Select from "react-select";
import { useLocation } from "react-router";

const DateRangeSelect = (props) => {
  const {
    dateHandler,
    isDisabled = false,
    onlyView = false,
    onChangeView,
    defaultType,
    defaultFortnightView,
    enableDailyView = false,
  } = props;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const location = useLocation();

  const [currentFortnight, setCurrent] = useState({ start: null, end: null });
  const [previousFortnight, setPrevious] = useState({ start: "", end: "" });

  const [selectedOption, setSelectedOption] = useState();

  const options = useMemo(() => {
    const base = [
      {
        value: "current",
        label: `Fortnight 1(${formatDateIntoDMM(
          currentFortnight?.start
        )}-${formatDateIntoDMM(currentFortnight?.end)})`,
      },
      {
        value: "previous",
        label: `Fortnight 2(${formatDateIntoDMM(
          previousFortnight?.start
        )}-${formatDateIntoDMM(previousFortnight?.end)})`,
      },
      {
        value: "weekly",
        label: `Weekly Period`,
      },
    ];

    if (enableDailyView) {
      base.push({ value: "daily", label: "Daily" });
    }

    return base;
  }, [currentFortnight, previousFortnight, enableDailyView]);

  // const defaultFortPrevAndCurrentOps = () => {
  //   const referenceMonday = moment("2025-01-06");
  //   const today = moment();

  //   const daysSinceRef = today.diff(referenceMonday, "days");
  //   const fortnightsSinceRef = Math.floor(daysSinceRef / 14);

  //   const currentMonday = moment(referenceMonday).add(
  //     fortnightsSinceRef * 14,
  //     "days"
  //   );
  //   const previousMonday = moment(currentMonday).subtract(7, "days");

  //   if (!defaultType || !defaultFortnightView) {
  //     setStartDate(currentMonday);
  //     setEndDate(moment(currentMonday).add(13, "days"));
  //   }
  //   if (!defaultFortnightView) {
  //     setSelectedOption({
  //       value: "current",
  //       label: `Fortnight 1(${formatDateIntoDMM(
  //         currentMonday
  //       )}-${formatDateIntoDMM(moment(currentMonday).add(13, "days"))})`,
  //     });
  //   }
  //   setPrevious({
  //     start: previousMonday,
  //     end: moment(previousMonday).add(13, "days"),
  //   });

  //   setCurrent({
  //     start: currentMonday,
  //     end: moment(currentMonday).add(13, "days"),
  //   });
  // };

  const defaultFortPrevAndCurrentOps = () => {
    const referenceMondayCurrent = moment("2025-01-06");
    const referenceMondayPrevious = moment("2025-01-13");

    const today = moment();

    const daysSinceRefCurrent = today.diff(referenceMondayCurrent, "days");
    const fortnightsSinceRefCurrent = Math.floor(daysSinceRefCurrent / 14);

    const daysSinceRefPrevious = today.diff(referenceMondayPrevious, "days");
    const fortnightsSinceRefPrevious = Math.floor(daysSinceRefPrevious / 14);

    const currentMonday = moment(referenceMondayCurrent).add(
      fortnightsSinceRefCurrent * 14,
      "days"
    );

    const previousMonday = moment(referenceMondayPrevious).add(
      fortnightsSinceRefPrevious * 14,
      "days"
    );

    const currentFortnightEnd = moment(currentMonday).add(13, "days");
    const previousFortnightEnd = moment(previousMonday).add(13, "days");

    if (today.isAfter(currentFortnightEnd)) {
      const nextCurrentMonday = moment(currentMonday).add(14, "days");
      setStartDate(nextCurrentMonday);
      setEndDate(moment(nextCurrentMonday).add(13, "days"));

      setSelectedOption({
        value: "current",
        label: `Fortnight 1(${formatDateIntoDMM(
          nextCurrentMonday
        )}-${formatDateIntoDMM(moment(nextCurrentMonday).add(13, "days"))})`,
      });

      const nextPreviousMonday = moment(nextCurrentMonday).subtract(7, "days");
      setPrevious({
        start: nextPreviousMonday,
        end: moment(nextPreviousMonday).add(13, "days"),
      });

      setCurrent({
        start: nextCurrentMonday,
        end: moment(nextCurrentMonday).add(13, "days"),
      });
    } else {
      setStartDate(currentMonday);
      setEndDate(currentFortnightEnd);

      setSelectedOption({
        value: "current",
        label: `Fortnight 1(${formatDateIntoDMM(
          currentMonday
        )}-${formatDateIntoDMM(currentFortnightEnd)})`,
      });

      setPrevious({
        start: previousMonday,
        end: previousFortnightEnd,
      });

      setCurrent({
        start: currentMonday,
        end: currentFortnightEnd,
      });
    }

    if (today.isAfter(previousFortnightEnd)) {
      const nextPreviousMonday = moment(previousMonday).add(14, "days");
      setPrevious({
        start: nextPreviousMonday,
        end: moment(nextPreviousMonday).add(13, "days"),
      });
    }
  };

  useEffect(() => {
    defaultFortPrevAndCurrentOps();
  }, []);

  useEffect(() => {
    if (startDate && endDate && dateHandler) {
      dateHandler({ startDate, endDate, view: selectedOption?.value });
    }
  }, [startDate, endDate]);

  //   useEffect(() => {
  //     defaultFortPrevAndCurrentOps();
  //     const startOfWeek = moment().startOf("iweek").isoWeekday(1);
  //     const endOfWeek = moment().startOf("iweek").isoWeekday(1).add(13, "days");
  //     if (!defaultType || !defaultFortnightView) {
  //       setStartDate(startOfWeek);
  //       setEndDate(endOfWeek);
  //     }
  //     if (!defaultFortnightView) {
  //       setSelectedOption({
  //         value: "current",
  //         label: `Fortnight 1(${formatDateIntoDMM(
  //           startOfWeek
  //         )}-${formatDateIntoDMM(endOfWeek)})`,
  //       });
  //     }
  //   }, []);

  useEffect(() => {
    if (selectedOption?.value) {
      updateDateRange(selectedOption.value);
    }
  }, [selectedOption]);

  // Update date range based on selection
  const updateDateRange = (option) => {
    if (option === "previous") {
      setStartDate(previousFortnight.start);
      setEndDate(previousFortnight.end);
    } else if (option === "current") {
      setStartDate(currentFortnight.start);
      setEndDate(currentFortnight.end);
    } else if (option === "weekly") {
      const currentMonday = moment().startOf("isoWeek");
      setStartDate(currentMonday);
      setEndDate(moment(currentMonday).add(6, "days"));
    }
  };

  const handleDateChange = (value) => {
    let startOfPeriod = null,
      endOfPeriod = null;

    if (value === "back") {
      if (selectedOption.value === "weekly") {
        startOfPeriod = moment(startDate).subtract(7, "days");
        endOfPeriod = moment(endDate).subtract(7, "days");
      } else {
        startOfPeriod = moment(startDate).subtract(14, "days");
        endOfPeriod = moment(endDate).subtract(14, "days");
      }
    } else if (value === "forward") {
      if (selectedOption.value === "weekly") {
        startOfPeriod = moment(startDate).add(7, "days");
        endOfPeriod = moment(endDate).add(7, "days");
      } else {
        startOfPeriod = moment(startDate).add(14, "days");
        endOfPeriod = moment(endDate).add(14, "days");
      }
    }

    setStartDate(startOfPeriod);
    setEndDate(endOfPeriod);
  };

  const handleOptionChange = (option) => {
    console.log({ option });
    setSelectedOption(option);

    if (onlyView && onChangeView) {
      onChangeView(option);
    }
  };

  // Effect for initial selection
  useEffect(() => {
    if (defaultType && defaultType === "fortnightly" && defaultFortnightView) {
      setSelectedOption(
        defaultFortnightView === "f1"
          ? {
              value: "current",
              label: `Fortnight 1(${formatDateIntoDMM(
                currentFortnight?.start
              )}-${formatDateIntoDMM(currentFortnight?.end)})`,
            }
          : {
              value: "previous",
              label: `Fortnight 2(${formatDateIntoDMM(
                previousFortnight?.start
              )}-${formatDateIntoDMM(previousFortnight?.end)})`,
            }
      );
    } else if (defaultType && defaultType === "weekly") {
      setSelectedOption(options.find((o) => o.value === "weekly") || options[2]);
    } else if (defaultType && defaultType === "daily" && enableDailyView) {
      setSelectedOption(options.find((o) => o.value === "daily"));
    }
  }, [
    onlyView,
    defaultType,
    defaultFortnightView,
    currentFortnight,
    previousFortnight,
    enableDailyView,
    options,
  ]);

  if (onlyView) {
    return (
      <Select
        className={`${
          location.pathname === "/rostering/schedule" ? "z-20" : "z-9"
        }`}
        value={selectedOption}
        onChange={(option) => handleOptionChange(option)}
        options={options}
        styles={{
          control: (provided, state) => ({
            ...provided,
            backgroundColor: "white",
            borderColor: state.isFocused ? "#63b3ed" : "#ccc",
          }),
          option: (provided, state) => ({
            ...provided,
            color: "#000",
            padding: "15px",
          }),
        }}
      />
    );
  }

  return (
    <div className='flex space-x-1 w-full'>
      <div className='flex-1'>
        <label className='text-sm text-gray-700 font-medium leading-5'>
          Choose Period
        </label>
        <div className='flex items-center w-full rounded text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'>
          <Select
            className={`w-full text-sm font-medium leading-5 bg-transparent border-none outline-none text-white ${
              location.pathname === "/rostering/schedule" ? "z-20" : "z-9"
            }`}
            value={selectedOption}
            onChange={(option) => handleOptionChange(option)}
            options={options}
            styles={{
              control: (provided, state) => ({
                ...provided,
                backgroundColor: "white",
                borderColor: state.isFocused ? "#63b3ed" : "#ccc",
              }),
              option: (provided, state) => ({
                ...provided,
                color: "#000",
                padding: "15px",
              }),
            }}
          />
        </div>
      </div>
      <div className='flex-1'>
        <label className='text-sm text-gray-700 font-medium leading-5 ml-1'>
          Select Date Range
        </label>
        <div className='flex'>
          <div
            onClick={() =>
              startDate && endDate && !isDisabled
                ? handleDateChange("back")
                : {}
            }
            role='button'
            tabIndex={0}
            className='flex items-center w-[15%] px-2 rounded background-gradient border-gradient text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
          >
            <MdArrowBackIos
              style={{
                padding: "0px 2px 0px 2px",
              }}
            />
          </div>
          <div
            style={{ display: "flex", fontSize: "13px" }}
            className='text-sm w-full flex justify-center mx-1 items-center bg-[#4b6bb710] focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md did-floating-input whitespace-nowrap'
          >
            {`${startDate && formatDateIntoDMMMY(startDate)}  -  ${
              endDate && formatDateIntoDMMMY(endDate)
            }`}
          </div>
          <div
            onClick={() =>
              startDate && endDate && !isDisabled
                ? handleDateChange("forward")
                : {}
            }
            role='button'
            tabIndex={0}
            className='flex items-center w-[15%] px-2 rounded background-gradient border-gradient text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
          >
            <MdArrowForwardIos
              style={{
                padding: "2px",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateRangeSelect;

// import React, { useEffect, useMemo, useState } from "react";
// import moment from "moment";
// import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
// import { formatDateIntoDMM, formatDateIntoDMMMY } from "Utils/utils";
// import Select from "react-select";
// import { useLocation } from "react-router";

// const DateRangeSelect = (props) => {
//   const {
//     dateHandler,
//     isDisabled = false,
//     onlyView = false,
//     onChangeView,
//     defaultType,
//     defaultFortnightView,
//   } = props;
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const location = useLocation();

//   const [currentForthnight, setCurrent] = useState({ start: null, end: null });
//   const [previousFortnight, setPrevious] = useState({ start: "", end: "" });

//   const [selectedOption, setSelectedOption] = useState();

//   const options = useMemo(
//     () => [
//       {
//         value: "current",
//         label: `Fortnight 1(${formatDateIntoDMM(
//           currentForthnight?.start
//         )}-${formatDateIntoDMM(currentForthnight?.end)})`,
//       },
//       {
//         value: "previous",
//         label: `Fortnight 2(${formatDateIntoDMM(
//           previousFortnight?.start
//         )}-${formatDateIntoDMM(previousFortnight?.end)})`,
//       },
//       {
//         value: "weekly",
//         label: `Weekly Period`,
//       },
//     ],
//     [currentForthnight, previousFortnight]
//   );

//   // const defaultFortPrevAndCurrentOps = () => {
//   //   const startOfWeek = moment().startOf("iweek").isoWeekday(1);
//   //   const endOfWeek = moment().startOf("iweek").isoWeekday(1).add(13, "days");
//   //   const currentMonday = moment().startOf("iweek").isoWeekday(1);
//   //   const previousMonday = moment(currentMonday).subtract(7, "days");
//   //   setPrevious({
//   //     start: previousMonday,
//   //     end: moment(previousMonday).add(13, "days"),
//   //   });
//   //   setCurrent({ start: startOfWeek, end: endOfWeek });
//   // };

//   const defaultFortPrevAndCurrentOps = () => {
//     const referenceMonday = moment("2025-01-06"); // e.g. first Monday of the year
//     const today = moment();

//     // Calculate number of full fortnights since the reference Monday
//     const daysSinceRef = today.diff(referenceMonday, 'days');
//     const fortnightsSinceRef = Math.floor(daysSinceRef / 14);

//     // Get current fortnight start (it should only change every 14 days)
//     const currentMonday = moment(referenceMonday).add(fortnightsSinceRef * 14, 'days');
//     const previousMonday = moment(currentMonday).subtract(7, 'days');
//   console.log({daysSinceRef,fortnightsSinceRef,currentMonday,previousMonday})
//     setPrevious({
//       start: previousMonday,
//       end: moment(previousMonday).add(13, 'days'),
//     });

//     setCurrent({
//       start: currentMonday,
//       end: moment(currentMonday).add(13, 'days'),
//     });
//   };

//   useEffect(() => {
//     defaultFortPrevAndCurrentOps();
//     const startOfWeek = moment().startOf("iweek").isoWeekday(1);
//     const endOfWeek = moment().startOf("iweek").isoWeekday(1).add(13, "days");
//     if (!defaultType || !defaultFortnightView) {
//       setStartDate(startOfWeek);
//       setEndDate(endOfWeek);
//     }
//     if (!defaultFortnightView) {
//       setSelectedOption({
//         value: "current",
//         label: `Fortnight 1(${formatDateIntoDMM(
//           startOfWeek
//         )}-${formatDateIntoDMM(endOfWeek)})`,
//       });
//     }
//   }, []);

//   useEffect(() => {
//     if (startDate && endDate && dateHandler) {
//       dateHandler({ startDate, endDate, view: selectedOption?.value });
//     }
//   }, [startDate, endDate]);

//   useEffect(() => {
//     if (selectedOption?.value) {
//       updateDateRange(selectedOption.value);
//     }
//   }, [selectedOption]);

//   const updateDateRange = (option) => {
//     const startOfWeek = moment().startOf("iweek").isoWeekday(1);
//     const endOfWeek = moment().startOf("iweek").isoWeekday(1).add(13, "days");

//     if (option === "previous") {
//       // Calculate the Monday of the current week and the Monday of the previous week
//       const currentMonday = moment().startOf("iweek").isoWeekday(1);
//       const previousMonday = moment(currentMonday).subtract(7, "days");

//       setStartDate(previousMonday);
//       setEndDate(moment(previousMonday).add(13, "days"));
//     } else if (option === "weekly") {
//       const currentMonday = moment().startOf("iweek").isoWeekday(1);
//       setStartDate(currentMonday);
//       setEndDate(moment(currentMonday).add(6, "days"));
//     } else {
//       setStartDate(startOfWeek);
//       setEndDate(endOfWeek);
//     }
//   };

//   const handleDateChange = (value) => {
//     let startOfWeek = null,
//       endOfWeek = null;

//     if (value === "back") {
//       if (selectedOption.value === "weekly") {
//         startOfWeek = moment(startDate).subtract(7, "days");
//         endOfWeek = moment(endDate).subtract(7, "days");
//       } else {
//         startOfWeek = moment(startDate).subtract(14, "days");
//         endOfWeek = moment(endDate).subtract(14, "days");
//       }
//     } else if (value === "forward") {
//       if (selectedOption.value === "weekly") {
//         startOfWeek = moment(startDate).add(7, "days");
//         endOfWeek = moment(endDate).add(7, "days");
//       } else {
//         startOfWeek = moment(startDate).add(14, "days");
//         endOfWeek = moment(endDate).add(14, "days");
//       }
//     }

//     setStartDate(startOfWeek);
//     setEndDate(endOfWeek);
//   };

//   const handleOptionChange = (option) => {
//     setSelectedOption(option);

//     if (onlyView && onChangeView) {
//       onChangeView(option);
//     }
//     // updateDateRange(option.value);
//   };

//   useEffect(() => {
//     const startOfWeek = moment().startOf("iweek").isoWeekday(1);
//     const endOfWeek = moment().startOf("iweek").isoWeekday(1).add(13, "days");
//     const currentMonday = moment().startOf("iweek").isoWeekday(1);
//     const previousMonday = moment(currentMonday).subtract(7, "days");
//     if (defaultType && defaultType === "fortnightly" && defaultFortnightView &&currentForthnight?.start && currentForthnight?.end && previousFortnight?.start && previousFortnight?.end) {
//       setSelectedOption(
//         defaultFortnightView === "f1"
//           ? {
//               value: "current",
//               label: `Fortnight 1(${formatDateIntoDMM(
//                 currentForthnight?.start
//               )}-${formatDateIntoDMM(currentForthnight?.end)})`,
//             }
//           : {
//               value: "previous",
//               label:`Fortnight 2(${formatDateIntoDMM(
//           previousFortnight?.start
//         )}-${formatDateIntoDMM(previousFortnight?.end)})`,
//             }
//       );
//     } else if (defaultType && defaultType === "weekly") {
//       setSelectedOption(options[2]);
//     }
//   }, [onlyView, defaultType, defaultFortnightView,currentForthnight?.start,currentForthnight?.end,previousFortnight?.start,previousFortnight?.end]);

//   if (onlyView) {
//     // console.log("defaultType", defaultType);p

//     return (
//       <Select
//         className={` ${
//           location.pathname === "/rostering/schedule" ? "z-20" : "z-9"
//         }`}
//         value={selectedOption}
//         onChange={(option) => handleOptionChange(option)}
//         options={options}
//         styles={{
//           control: (provided, state) => ({
//             ...provided,
//             backgroundColor: "white",
//             borderColor: state.isFocused ? "#63b3ed" : "#ccc",
//           }),
//           option: (provided, state) => ({
//             ...provided,
//             color: "#000",
//             padding: "15px",
//           }),
//         }}
//       />
//     );
//   }

//   return (
//     <div className='flex space-x-1 w-full'>
//       <div className='flex-1'>
//         <label className='text-sm text-gray-700 font-medium leading-5'>
//           Choose Period
//         </label>
//         <div className='flex items-center w-full rounded text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'>
//           <Select
//             className={`w-full text-sm font-medium leading-5 bg-transparent border-none outline-none text-white ${
//               location.pathname === "/rostering/schedule" ? "z-20" : "z-9"
//             }`}
//             value={selectedOption}
//             onChange={(option) => handleOptionChange(option)}
//             options={options}
//             styles={{
//               control: (provided, state) => ({
//                 ...provided,
//                 backgroundColor: "white",
//                 borderColor: state.isFocused ? "#63b3ed" : "#ccc",
//               }),
//               option: (provided, state) => ({
//                 ...provided,
//                 color: "#000",
//                 padding: "15px",
//               }),
//             }}
//           />
//         </div>
//       </div>
//       <div className='flex-1'>
//         <label className='text-sm text-gray-700 font-medium leading-5 ml-1'>
//           Select Date Range
//         </label>
//         <div className='flex'>
//           <div
//             onClick={() =>
//               startDate && endDate && !isDisabled
//                 ? handleDateChange("back")
//                 : {}
//             }
//             role='button'
//             tabIndex={0}
//             className='flex items-center w-[15%] px-2 rounded background-gradient border-gradient text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
//           >
//             <MdArrowBackIos
//               style={{
//                 padding: "0px 2px 0px 2px",
//               }}
//             />
//           </div>
//           <div
//             style={{ display: "flex", fontSize: "13px" }}
//             className='text-sm w-full flex justify-center mx-1 items-center bg-[#4b6bb710] focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md did-floating-input whitespace-nowrap'
//           >
//             {`${startDate && formatDateIntoDMMMY(startDate)}  -  ${
//               endDate && formatDateIntoDMMMY(endDate)
//             }`}
//           </div>
//           <div
//             onClick={() =>
//               startDate && endDate && !isDisabled
//                 ? handleDateChange("forward")
//                 : {}
//             }
//             role='button'
//             tabIndex={0}
//             className='flex items-center w-[15%] px-2 rounded background-gradient border-gradient text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
//           >
//             <MdArrowForwardIos
//               style={{
//                 padding: "2px",
//               }}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DateRangeSelect;
